module.exports = __webpack_public_path__ + "static/media/sourcesanspro-bold-webfont.f12f6a2f.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/source-sans-pro/sourcesanspro-bold-webfont.woff2
// module id = 500
// module chunks = 0